import React, { useState } from 'react'
import { withRouter, useParams } from 'react-router'
import './AltaHospitalarForm.css'

const AltaHospitalarForm = ({ history }) => {
  const { day } = useParams()

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: ''
  })

  const formatWhatsApp = (value) => {
    const numbers = value.replace(/\D/g, '')
    if (numbers.length <= 10) {
      return numbers.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
    }
    return numbers.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3')
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target

    if (name === 'whatsapp') {
      setFormData(prev => ({
        ...prev,
        [name]: formatWhatsApp(value)
      }))
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // Salvar dados no localStorage
    localStorage.setItem('certificateData', JSON.stringify(formData))

    // Navegar para a página de preview
    history.push(`/gerar-alta-hospitalar/preview/${day}`)
  }

  return (
    <div className="alta-hospitalar-container">
      <header>
        <img src="/images/logo-black.png" alt="Logo Aprova" className="header-logo" />
        <h1>Alta do Pronto-Atendimento – SOS ENEM 2025</h1>
        <p className="subtitle">Centro de Recuperação de Estudantes em Fase Final de Preparação</p>
        <p className="subtitle-small">Você está prestes a receber alta do tratamento intensivo!</p>
      </header>

      <main>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nome do Paciente</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Seu nome completo"
              required
              minLength={3}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="seu@email.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="whatsapp">WhatsApp</label>
            <input
              type="text"
              id="whatsapp"
              name="whatsapp"
              value={formData.whatsapp}
              onChange={handleInputChange}
              placeholder="(00) 00000-0000"
              required
              maxLength={15}
            />
          </div>

          <button type="submit" className="btn-generate">
            Receber Alta Hospitalar
          </button>
        </form>
      </main>

      <footer>
        <p>Preparando futuros aprovados desde 2025</p>
      </footer>
    </div>
  )
}

export default withRouter(AltaHospitalarForm)
